module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/bubble2.e49ae32a.png";